import { render, staticRenderFns } from "./relatorio-itens-excluidos.vue?vue&type=template&id=87c1b880&scoped=true"
import script from "./relatorio-itens-excluidos.vue?vue&type=script&lang=js"
export * from "./relatorio-itens-excluidos.vue?vue&type=script&lang=js"
import style0 from "./relatorio-itens-excluidos.vue?vue&type=style&index=0&id=87c1b880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1b880",
  null
  
)

export default component.exports